import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { BUILTIN_ROLES, type BuiltinRoleId } from "../rbac/roles";
import { mutator } from "./mutator";

export const deleteSkillSchema = z.object({
  skillId: z.string(),
});

export const deleteSkill = mutator({
  schema: deleteSkillSchema,
  resolve: {
    skill: { kind: "skill", from: "skillId" },
  },
  permissions: [
    {
      permission: "skill:write",
      scopeId: ({ args }) => args.skill.id,
    },
  ],
  fn: async ({ tx, args: { skill } }) => {
    const grants = await tx.run(
      zql.roleGrants.where("scopeId", skill.id).related("customRole")
    );
    for (const g of grants) {
      const scopeKind = g.builtinRoleId
        ? BUILTIN_ROLES[g.builtinRoleId as BuiltinRoleId]?.scopeKind
        : g.customRole?.scopeKind;
      if (scopeKind !== "skill") continue;
      await tx.mutate.roleGrants.delete({ id: g.id });
    }
    await tx.mutate.skills.delete({ id: skill.id });
  },
});
